<template>
	<footer class="footer">
		<div class="container">
			<nav>
				<ul>
					<li>
						<a href="mailto:experts@gmd-sanitation.com" target="_blank">
							experts@gmd-sanitation.com
						</a>
					</li>
					<li>
						<a href="tel:0475404750" target="_blank">
							04 75 40 47 50
						</a>
					</li>
				</ul>
			</nav>
			<div class="copyright text-center">
				GMD Sanitation - 85 rue Conrad Kilian 07500 Guilherand-Granges
			</div>
		</div>
	</footer>
</template>

<script>
export default {
	name: "Footer"
}
</script>

<style scoped>

</style>
